import {
  TServerErrorResponse,
  Client,
  ClientWritePayload,
  Conversation,
} from "@/types";
import { http } from "../httpHandler";
import { links } from "@/constants";

export const CLIENT_GET = "client-get";
export const CLIENT_ALL_GET = "client-all-get";
export const CLIENT_ALL_BY_IDS_GET = "client-all-by-ids-get";

export interface GetClientListParams {
  take: number;
  skip: number;
  search: string;
  sortBy: string;
  asc: boolean;
  clientIds?: string;
}

export const getClient = async (clientId: string) => {
  try {
    const response = await http.get<Client>(links.client.clientById(clientId));
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const getAllClients = async (
  params: Partial<GetClientListParams> & { isCrmContact?: boolean } = {},
): Promise<Client[]> => {
  try {
    const response = await http.get<Client[]>(links.client.index, {
      params: { ...params },
    });

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const createClient = async (client: ClientWritePayload) => {
  try {
    const response = await http.post<Client>(links.client.index, client);

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const updateClient = async (client: ClientWritePayload) => {
  if (!client.id) return;
  const { id, ...rest } = client;
  try {
    const response = await http.patch<Client>(
      links.client.clientById(id),
      rest,
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
export const deleteClient = async ({
  clientId,
  removeFromCrm,
}: {
  clientId: string;
  removeFromCrm?: boolean;
}) => {
  try {
    const response = await http.delete<Client>(
      links.client.clientById(clientId),
      { params: { removeFromCrm } },
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const getClientConversations = async (clientId: string) => {
  try {
    const response = await http.get<Conversation[]>(
      links.client.clientConversationById(clientId),
      { params: { asc: false } },
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
